import { createAction } from '@reduxjs/toolkit';
import type LabelValue from 'commons/modules/label-value';
import type { RootState } from './configureStore';
import { createReportSlice } from './reportStore';

// Initial filter keys for Audits report (10 filtros - el más complejo)
const initialFilters = {
  account: '',
  advisor: '',
  client: '',
  institute: '',
  instrument: '',
  issuer: '',
  marketType: '',
  operationType: '',
  portfolio: '',
  strategy: '',
};

// Custom actions for report types
export const setReportType = createAction<string>(
  'operationAudits/setReportType',
);

export const setReportTypes = createAction<LabelValue[]>(
  'operationAudits/setReportTypes',
);

// Create generic slice instance for this report with custom extensions
const slice = createReportSlice<any>(
  'operationAudits',
  initialFilters,
  (builder) => {
    // Handle setReportType
    builder.addCase(setReportType, (state, action) => {
      if (state.reportType !== undefined) {
        state.reportType = action.payload;
      }
    });

    // Handle setReportTypes
    builder.addCase(setReportTypes, (state, action) => {
      if (state.reportTypes !== undefined) {
        state.reportTypes = action.payload;
      }
    });
  },
);

// Custom cleanDataQuery that preserves dates and reportType
export const cleanDataQuery =
  () => (dispatch: any, getState: () => RootState) => {
    const audits = (getState().entities as any).operationAudits;
    const { dates, reportType } = audits;

    dispatch({ type: 'operationAudits/cleanAll' });

    if (dates) {
      dispatch({
        type: 'operationAudits/setStartDate',
        payload: dates.startDate,
      });
      dispatch({ type: 'operationAudits/setEndDate', payload: dates.endDate });
    }
    if (reportType !== undefined) {
      dispatch(setReportType(reportType));
    }
  };

// Custom reducer wrapper to initialize reportType fields
const baseReducer = slice.reducer;
export default (state: any, action: any) => {
  // Initialize reportType fields if not present
  if (!state) {
    return baseReducer(
      {
        ...slice.getInitialState(),
        reportType: '',
        reportTypes: [{ label: 'Ninguno', value: '' }],
      },
      action,
    );
  }
  return baseReducer(state, action);
};

export const getReportType = (state: RootState) =>
  state.entities.operationAudits.reportType || '';

export const getReportTypes = (state: RootState) =>
  state.entities.operationAudits.reportTypes || [];
